export const PAYMENT_SUCCESS_INFORMATION = {
  11: [
    { name: "购买省份：", key: "areaDtoList", maxWidth: "200px", childrenKey: "areaName" },
    { name: "开通账号：", key: "userName" },
    { name: "购买内容：", key: "payTypeName" },
    { name: "到期时间：", key: "endTime" },
    { name: "实付金额：", key: "money", symbol: "￥" },
    { name: "支付方式：", key: "paymentType" },
  ],
  12: [
    { name: "购买数量：", key: "buyCount" },
    { name: "开通账号：", key: "userName" },
    { name: "购买内容：", key: "payTypeName" },
    { name: "到期时间：", key: "endTime" },
    { name: "实付金额：", key: "money", symbol: "￥" },
    { name: "支付方式：", key: "paymentType" },
  ],
  14: [
    { name: "购买数量：", key: "buyCount" },
    { name: "开通账号：", key: "userName" },
    { name: "购买内容：", key: "payTypeName" },
    { name: "到期时间：", key: "endTime" },
    { name: "实付金额：", key: "money", symbol: "￥" },
    { name: "支付方式：", key: "paymentType" },
  ],
};
export const PAYMENT_INFORMATION = {
  11: [
    { name: "已选省份：", key: "areaDtoList", childrenKey: "areaName", width: "488px" },
    { name: "开通账号：", key: "userName" },
    { name: "购买内容：", key: "payTypeName" },
    { name: "实付金额：", key: "money", color: "#DF6250", fontWeight: 550, symbol: "￥" },
    { name: "到期时间：", key: "endTime" },
  ],
  12: [
    { name: "购买数量：", key: "buyCount" },
    { name: "开通账号：", key: "userName" },
    { name: "开通套餐：", key: "payTypeName" },
    { name: "到期时间：", key: "endTime" },
    { name: "实付金额：", key: "money", color: "#DF6250", fontWeight: 550, symbol: "￥" },
  ],
  14: [
    { name: "购买数量：", key: "buyCount" },
    { name: "开通账号：", key: "userName" },
    { name: "开通套餐：", key: "payTypeName" },
    { name: "到期时间：", key: "endTime" },
    { name: "实付金额：", key: "money", color: "#DF6250", fontWeight: 550, symbol: "￥" },
  ],
};
